import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import helperMixins from '@/mixins/Helper'

import Login from '@/pages/Login'
import Password from '@/pages/Password/Password'
import RequestPassword from '@/pages/Password/Request'
import ResetPassword from '@/pages/Password/Reset'

import Index from '@/pages/Index'

import Dashboard from '@/pages/Dashboard'
import DashboardOverview from '@/pages/Dashboard/Overview'
import DashboardReport from '@/pages/Dashboard/Report'

import Machine from '@/pages/Machine'
import MachineList from '@/pages/Machine/List'
import MachineCreate from '@/pages/Machine/Create'
import MachineDetail from '@/pages/Machine/Detail'

import Settlements from '@/pages/Settlements'

import User from '@/pages/User'
import UserList from '@/pages/User/List'
import UserCreate from '@/pages/User/Create'
import UserDetail from '@/pages/User/Detail'

import Deal from '@/pages/Deal'
import DealList from '@/pages/Deal/List'
import DealCreate from '@/pages/Deal/Create'
import DealDetail from '@/pages/Deal/Detail'

import Active from '@/pages/Active'
import ActiveList from '@/pages/Active/List'
import ActiveCreate from '@/pages/Active/Create'
import ActiveDetail from '@/pages/Active/Detail'
import ActiveSerialNumber from '@/pages/Active/SerialNumber'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: Login
        },
        {
            path: '/password',
            component: Password
        },
        {
            path: '/password/request',
            component: RequestPassword
        },
        {
            path: '/password/reset',
            component: ResetPassword
        },
        {
            path: '/',
            component: Index,
            redirect: '/dashboard/overview',
            children: [
                {
                    path: 'dashboard',
                    component: Dashboard,
                    children: [
                        {
                            path: 'overview',
                            component: DashboardOverview,
                        },
                        {
                            path: 'report',
                            component: DashboardReport,
                        }
                    ]
                }, {
                    path: 'machine',
                    component: Machine,
                    children: [
                        {
                            path: 'list',
                            component: MachineList,
                        },
                        {
                            path: 'create',
                            component: MachineCreate
                        },
                        {
                            path: ':id',
                            component: MachineDetail,
                        },
                    ]
                }, {
                    path: 'settlements',
                    component: Settlements
                }, {
                    path: 'user',
                    component: User,
                    children: [
                        {
                            path: 'list',
                            component: UserList,
                        },
                        {
                            path: 'create',
                            component: UserCreate
                        },
                        {
                            path: ':id',
                            component: UserDetail,
                        }
                    ]
                },
                {
                    path: 'deal',
                    component: Deal,
                    children: [
                        {
                            path: 'list',
                            component: DealList,
                        },
                        {
                            path: 'create',
                            component: DealCreate
                        },
                        {
                            path: ':id',
                            component: DealDetail,
                        },
                    ]
                },
                {
                    path: 'active',
                    component: Active,
                    children: [
                        {
                            path: 'list',
                            component: ActiveList,
                        },
                        {
                            path: 'create',
                            component: ActiveCreate
                        },
                        {
                            path: ':id',
                            component: ActiveDetail,
                        },
                        {
                            path: 'serial-number/:id',
                            component: ActiveSerialNumber,
                        },
                    ]
                }
            ]
        }
    ],

    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    helperMixins.methods.toggleLoading(true)

    const cookies = Cookies.get("cocobar")
    if (cookies) {
        const { access_token, role_id } = JSON.parse(cookies)

        if (access_token && !store.state.admin.jwt.access_token) {
            store.dispatch('admin/set_jwt', {
                access_token: access_token,
                role_id: role_id
            })
        }
    }



    // 沒登入不能進後台
    if ((to.path !== '/login' && to.path.indexOf('/password') === -1) && !store.state.admin.jwt.access_token) {
        router.push('/login')
    }

    next()

    helperMixins.methods.toggleLoading(false)
})

export default router
